// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC0MKsArSxOX33X_bQg-m1F0G3yAi-9XVI",
  authDomain: "myweb-c2038.firebaseapp.com",
  projectId: "myweb-c2038",
  storageBucket: "myweb-c2038.appspot.com",
  messagingSenderId: "697949865933",
  appId: "1:697949865933:web:3cd943e9471c162a1a2684",
  measurementId: "G-EGNMY7JEQ1"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
